// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-l_fv","catalogByServiceItem__title":"c-l_fw"};